// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DownloadSection_wrapper__2HR-g","item":"DownloadSection_item__31dCR","icon":"DownloadSection_icon__2M0Lv"};